import AreaFactory from './area-factory';
import WallFactory from './wall-factory';

export { AreaFactory, WallFactory };

export default {
  WallFactory,
  AreaFactory
};
